<template>
  <section class="wrap">
    <div class="container-wrap observer-selector">
      <div class="content">
        <div>나에게 Fit한 배송, 디버<br />지금 경험해 보세요!</div>
        <div class="button-wrap">
          <button @click="moveOrder" class="primary">주문접수</button>
          <button
            v-if="isAuthenticated"
            @click="moveFaq"
            class="primary outline"
          >
            자주묻는 질문
          </button>
          <button v-else @click="moveJoin" class="primary outline">
            간편 회원가입
          </button>
        </div>
      </div>
      <img src="@/assets/img/home/main_group.png" />
    </div>
  </section>
</template>
<script>
export default {
  methods: {
    moveOrder() {
      this.$router.push("/orders/form");
    },
    moveJoin() {
      this.$router.push("/join/intro");
    },
    moveFaq() {
      this.$router.push("/services/faq");
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters["auth/isAuthenticated"]();
    }
  }
};
</script>
<style src="../home.common.css" scoped />
<style scoped>
.container-wrap {
  border-radius: 32px;

  background: linear-gradient(180deg, #e4f1fc 0%, #f0f9ff 100%);

  background-color: var(--primary-100);
}

.content {
  font-size: 28px;
  line-height: 40px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 64px 36px 48px 36px;
  gap: 36px;
  color: var(--gray-700);
}

img {
  width: 458px;
  height: 100%;
  display: none;
}

.button-wrap {
  display: flex;
  gap: 12px;
  width: 100%;
}

button {
  width: 50%;
  padding: 0px;
}

@media (min-width: 1024px) {
  .container-wrap {
    display: flex;
    justify-content: space-between;
  }

  .content {
    padding: 80px 0px 0px 80px;
    text-align: left;
    font-size: 32px;
    line-height: 44px;
    width: 404px;
  }

  .button-wrap {
    gap: 20px;
  }

  img {
    display: block;
  }
}
</style>
